export const GET_PROGRESS_DATA = "GET_PROGRESS_DATA";
export const SET_PROGRESS_LOADING = "SET_PROGRESS_LOADING";
export const GET_MY_LESSON_NAMES_LOADING = "GET_MY_LESSON_NAMES_LOADING";
export const GET_MY_LESSON_NAMES = "GET_MY_LESSON_NAMES";
